import { Store, select } from '@ngrx/store';
import { Injectable } from '@angular/core';

import { ShellState } from './shell.reducer';
import {
  siteNavLoad,
  headerNavLoad,
  reset,
  logout,
  loginStepup,
} from './shell.actions';
import { shellQuery } from './shell.selectors';

import { LogoutVariations } from '@cigna/chcp/shared/util';

@Injectable({
  providedIn: 'root',
})
export class ShellFacade {
  profileNav$ = this.store$.pipe(select(shellQuery.getProfileNavLinks));
  profileNavError$ = this.store$.pipe(select(shellQuery.getProfileNavError));
  siteNav$ = this.store$.pipe(select(shellQuery.getSiteNav));
  siteNavError$ = this.store$.pipe(select(shellQuery.getSiteNavError));
  hasWamApproval$ = this.store$.pipe(select(shellQuery.getHasWamApproval));

  constructor(private store$: Store<ShellState>) {}

  loadNav(): void {
    this.store$.dispatch(siteNavLoad());
    this.store$.dispatch(headerNavLoad());
  }

  logOut(data: { variation: LogoutVariations; linkName: string }): void {
    this.store$.dispatch(logout(data));
  }

  loginStepUp() {
    this.store$.dispatch(loginStepup());
  }

  reset(): void {
    this.store$.dispatch(reset());
  }

  loadWamApprovalStatus(): void {
    // Dispatch action to load WAM approval status
    this.store$.dispatch({ type: '[Shell] WAM Approval Status Load' });
  }
}
